module.exports = __webpack_public_path__ + "img/ch08_08_扶梯恐惧.3b59e5e5.jpg";